/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface PaymentsService {
  /** @summary Create Manual Attempt */
  createManualAttemptInvoicesInvoiceIdAttemptsPost: {
    /** @summary Create Manual Attempt */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
        CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateManualAttemptInvoicesInvoiceIdAttemptsPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
          CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
          CreateManualAttemptInvoicesInvoiceIdAttemptsPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
        CreateManualAttemptInvoicesInvoiceIdAttemptsPostError
      >
    >;
    /** @summary Create Manual Attempt */
    getMutationKey(
      parameters: DeepReadonly<CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters> | void
    ): ServiceOperationMutationKey<
      CreateManualAttemptInvoicesInvoiceIdAttemptsPostSchema,
      CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Manual Attempt
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.paymentsService.createManualAttemptInvoicesInvoiceIdAttemptsPost.useMutation({
     *     path: {
     *         invoice_id: invoiceId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.paymentsService.createManualAttemptInvoicesInvoiceIdAttemptsPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         invoice_id: invoiceId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateManualAttemptInvoicesInvoiceIdAttemptsPostSchema,
        CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
        CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
        TVariables,
        OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
      OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Manual Attempt
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.paymentsService.createManualAttemptInvoicesInvoiceIdAttemptsPost.useMutation({
     *     path: {
     *         invoice_id: invoiceId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.paymentsService.createManualAttemptInvoicesInvoiceIdAttemptsPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         invoice_id: invoiceId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
        CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateManualAttemptInvoicesInvoiceIdAttemptsPostSchema,
        CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
        CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
        TVariables,
        OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
      OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Manual Attempt
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createManualAttemptInvoicesInvoiceIdAttemptsPostTotal = qraft.paymentsService.createManualAttemptInvoicesInvoiceIdAttemptsPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createManualAttemptInvoicesInvoiceIdAttemptsPostTotal = qraft.paymentsService.createManualAttemptInvoicesInvoiceIdAttemptsPost.useIsMutating({
     *     parameters: {
     *         path: {
     *             invoice_id: invoiceId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
            OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostSchema,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
            OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Manual Attempt
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createManualAttemptInvoicesInvoiceIdAttemptsPostPendingMutationVariables = qraft.paymentsService.createManualAttemptInvoicesInvoiceIdAttemptsPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createManualAttemptInvoicesInvoiceIdAttemptsPostMutationData = qraft.paymentsService.createManualAttemptInvoicesInvoiceIdAttemptsPost.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 invoice_id: invoiceId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
        OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
        MutationVariables<
          CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
          CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
            OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostSchema,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
            OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
          OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
          MutationVariables<
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create Manual Attempt */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
            OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostSchema,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
            OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Manual Attempt
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.paymentsService.createManualAttemptInvoicesInvoiceIdAttemptsPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             invoice_id: invoiceId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.paymentsService.createManualAttemptInvoicesInvoiceIdAttemptsPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
              OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostSchema,
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
              OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostError,
            MutationVariables<
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
              OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostSchema,
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
              CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters,
              OperationError<CreateManualAttemptInvoicesInvoiceIdAttemptsPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateManualAttemptInvoicesInvoiceIdAttemptsPostData,
          CreateManualAttemptInvoicesInvoiceIdAttemptsPostError,
          MutationVariables<
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody,
            CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters
          >,
          TContext
        >
      >;
    };
    schema: CreateManualAttemptInvoicesInvoiceIdAttemptsPostSchema;
    types: {
      parameters: CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters;
      data: CreateManualAttemptInvoicesInvoiceIdAttemptsPostData;
      error: CreateManualAttemptInvoicesInvoiceIdAttemptsPostError;
      body: CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody;
    };
  };
}
/** @summary Create Manual Attempt */
export const createManualAttemptInvoicesInvoiceIdAttemptsPost = {
  schema: {
    method: 'post',
    url: '/invoices/{invoice_id}/attempts',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateManualAttemptInvoicesInvoiceIdAttemptsPostSchema;
  [QraftServiceOperationsToken]: PaymentsService['createManualAttemptInvoicesInvoiceIdAttemptsPost'];
};
export const paymentsService = {
  createManualAttemptInvoicesInvoiceIdAttemptsPost,
} as const;
type CreateManualAttemptInvoicesInvoiceIdAttemptsPostSchema = {
  method: 'post';
  url: '/invoices/{invoice_id}/attempts';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateManualAttemptInvoicesInvoiceIdAttemptsPostParameters =
  paths['/invoices/{invoice_id}/attempts']['post']['parameters'];
type CreateManualAttemptInvoicesInvoiceIdAttemptsPostData =
  paths['/invoices/{invoice_id}/attempts']['post']['responses']['200']['content']['application/json'];
type CreateManualAttemptInvoicesInvoiceIdAttemptsPostError =
  paths['/invoices/{invoice_id}/attempts']['post']['responses']['422']['content']['application/json'];
type CreateManualAttemptInvoicesInvoiceIdAttemptsPostBody =
  paths['/invoices/{invoice_id}/attempts']['post']['requestBody']['content']['application/json'];
